import { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useToastAlert } from '@design-systems/canvas-ui'
import { UserContext } from 'App/UserContext'
import {
  BP_ROLE_TYPE_LOOKUP_TABLE,
  PLM_SUPPORTED_ROLE_TYPES,
} from 'config/BusinessPartnerConsts'

/**
 * Headless component that nudges external users who have more than one
 * approved partner type toward the account settings page, where they can
 * review or change their default partner type.
 */
export const PartnerTypeToaster = () => {
  const { sparkUser } = useContext(UserContext)
  const makeToast = useToastAlert()
  const navigate = useNavigate()
  const hasShownToast = useRef(false)

  useEffect(() => {
    const approvedVMMRoles = sparkUser?.approvedVMMRoles ?? []
    const hasMultiplePartnerTypes =
      PLM_SUPPORTED_ROLE_TYPES.filter((roleType) =>
        approvedVMMRoles.includes(roleType),
      ).length > 1

    if (
      sparkUser &&
      !sparkUser.internal &&
      sparkUser.currentVMMRole &&
      hasMultiplePartnerTypes &&
      !hasShownToast.current
    ) {
      hasShownToast.current = true
      makeToast({
        variant: 'caution',
        heading: 'Default partner type',
        message: `You are currently logged in as ${
          BP_ROLE_TYPE_LOOKUP_TABLE[
            sparkUser.currentVMMRole as keyof typeof BP_ROLE_TYPE_LOOKUP_TABLE
          ]
        } for ${sparkUser.companyName}`,
        links: [
          {
            text: 'Go to account settings',
            onClick: () => navigate('/account'),
          },
        ],
      })
    }
  }, [sparkUser, makeToast, navigate])

  return null
}

export default PartnerTypeToaster
